var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "task-center-list" }, [_c('div', { staticClass: "task-center-header" }, [_vm._v("\n    " + _vm._s(_vm.$t('playTurbo.taskCenter.headerTitle')) + "\n  ")]), _vm._v(" "), _vm.data.length === 0 ? _c('div', { staticClass: "task-center-empty" }, [_vm._v("\n    " + _vm._s(_vm.$t('playTurbo.taskCenter.noData')) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.data, function (item) {
    return _c('task-center-item', { key: item.id, attrs: { "data": item }, on: { "jump": function jump($event) {
          return _vm.$emit('jump');
        } } });
  }), _vm._v(" "), _vm.data.length > 0 ? _c('div', { staticClass: "task-center-desc" }, [_vm._v("\n    " + _vm._s(_vm.$t('playTurbo.taskCenter.limitData')) + "\n  ")]) : _vm._e()], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };